import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps } from './selectors';
import { getIsFeatureVisible } from './utils';
import { FeatureProps } from './types';

const CropFeatureToggle = lazy(() =>
  import('./CropFeatureToggle').then((m) => ({
    default: m.CropFeatureToggle,
  })),
);

interface Proptype extends FeatureProps {
  children: any;
}

const ToggleFeature: React.FC<React.PropsWithChildren<Proptype>> = ({
  cropUuid,
  countryCode,
  featureName,
  children,
  defaultFeatures,
  regionalFeatures,
  tokenFeatures,
  qaFeatures,
}) => {
  if (cropUuid) {
    return (
      <Suspense fallback={null}>
        <CropFeatureToggle
          cropUuid={cropUuid}
          countryCode={countryCode}
          featureName={featureName}
        >
          {children}
        </CropFeatureToggle>
      </Suspense>
    );
  }

  const isFeatureVisible = getIsFeatureVisible({
    countryCode,
    featureName,
    defaultFeatures,
    regionalFeatures,
    tokenFeatures,
    qaFeatures,
  });

  return <>{isFeatureVisible && children}</>;
};

const FeatureToggle = connect(mapStateToProps)(ToggleFeature);

export { FeatureToggle };
